<template>
  <div class="container-fluid">
    <div class="block-header">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <div class="card card-top-line">
          <ValidationObserver v-slot="{ passes }">
            <div class="header">
              <h2>Create Coupon Code Campaign</h2>
            </div>
            <div class="body add-fund-form">
              <form @submit.prevent="passes(CouponDataSubmit)" id="basic-form">
                <div class="body">
                  <ValidationProvider
                    name="select_country"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <div class="country-dropdown">
                      <div
                        class="form-group form-select multiselect-grp"
                        :class="{
                          errors: errors[0],
                          success:
                            active_Coupon &&
                            active_Coupon.length != 0 &&
                            !errors[0],
                        }"
                      >
                        <span class="float-label">
                          <label for="Country">
                            Select Active Coupon Code*
                          </label>
                          <multiselect
                            placeholder=""
                            v-model="active_Coupon"
                            :show-labels="false"
                            :options="creditType_Options"
                            :searchable="false"
                          ></multiselect>
                          <i
                            class="fa fa-times"
                            v-if="errors.length && errors[0]"
                          ></i>
                          <i
                            class="fa fa-check"
                            v-if="
                              active_Coupon &&
                              active_Coupon.length != 0 &&
                              !errors[0]
                            "
                          ></i>
                        </span>
                      </div>
                    </div>
                  </ValidationProvider>
                  <div
                    class="d-flex justify-content-between flex-md-row flex-column"
                  >
                    <div class="form-group flex-fill">
                      <span class="cursor-pointer" @click="selectAll('add')">
                        Select All
                      </span>
                      <span class="cursor-pointer" @click="Addoptions = []">
                        Select None
                      </span>
                      <select
                        class="form-control"
                        v-model="Addoptions"
                        id="test"
                        multiple
                        size="10"
                      >
                        <option v-for="(item, index) in options" :key="index">
                          {{ item }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="select-action d-flex flex-md-column px-md-5 py-md-0 py-2 justify-content-center align-items-center"
                    >
                      <button
                        class="btn btn-primary d-flex align-items-center justify-content-center"
                        type="button"
                        @click="add"
                      >
                        <i class="icon-arrow-right font-weight-bold"></i>
                      </button>
                      <button
                        class="btn btn-primary d-flex align-items-center justify-content-center"
                        type="button"
                        @click="remove"
                      >
                        <i class="icon-arrow-left font-weight-bold"></i>
                      </button>
                    </div>
                    <div class="form-group flex-fill">
                      <span class="cursor-pointer" @click="selectAll('remove')">
                        Select All
                      </span>
                      <span class="cursor-pointer" @click="removeOptions = []">
                        Select None
                      </span>
                      <select
                        class="form-control"
                        v-model="removeOptions"
                        id="test"
                        multiple
                        size="10"
                      >
                        <option
                          v-for="(item, index) in selectedOptions"
                          :key="index"
                        >
                          {{ item }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div
                  class="d-flex flex-column flex-md-row justify-content-center"
                >
                  <b-button
                    variant="secondary btn-mw"
                    size="lg"
                    @click="$router.back()"
                  >
                    Cancel
                  </b-button>
                  <b-button
                    type="submit"
                    variant="primary ml-md-1 mt-2 mt-md-0 btn-mw"
                    size="lg"
                  >
                    Submit
                  </b-button>
                </div>
              </form>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const BreadCrumb = require("@/components/BreadCrumb.vue").default;
const { ValidationObserver, ValidationProvider } = require("vee-validate");
import "@/plugins/vee-validate";
import { mapState, mapGetters } from "vuex";
export default {
  name: "CreateEmailCouponComponent",
  components: {
    BreadCrumb,
    ValidationObserver,
    ValidationProvider,
    Multiselect: () => import("vue-multiselect"),
  },
  data() {
    return {
      active_Coupon: "",
      creditType_Options: [
        "WELCOME",
        "FREE50",
        "HELLO150",
        "WELCOME",
        "TRY200",
      ],
      options: [
        "Test 1",
        "Test 2",
        "Test 3",
        "Test 4",
        "Test 5",
        "Test 6",
        "Test 7",
        "Test 8",
        "Test 9",
      ],
      Addoptions: [],
      removeOptions: [],
      selectedOptions: [],
    };
  },
  methods: {
    CouponDataSubmit() {
      console.log(this.active_Coupon);
      console.log(this.selectedOptions);
    },
    selectAll(tab) {
      if (tab == "add") {
        this.options.map((item) => {
          this.Addoptions.push(item);
        });
      } else {
        this.selectedOptions.map((item) => {
          this.removeOptions.push(item);
        });
      }
    },
    add() {
      this.Addoptions.map((item) => {
        this.options.map((sub, index) => {
          if (sub == item) {
            this.options.splice(index, 1);
            this.selectedOptions.push(item);
          }
        });
      });
    },
    remove() {
      this.removeOptions.map((item) => {
        this.selectedOptions.map((sub, index) => {
          if (sub == item) {
            delete this.selectedOptions.splice(index, 1);
            this.options.push(item);
          }
        });
      });
    },
  },
  mounted() {},
  computed: {
    ...mapGetters(["isLoading"]),
    ...mapState({
      apiErrors: (state) => state.auth.errors,
    }),
  },
};
</script>
